export default "__VITE_ASSET__DvDL2r7C__"